import React, { Component } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";

import Pitches from "../components/Pitches";
import * as projectActions from "./../../../../../actions/project.actions";
import * as commonActions from "./../../../../../actions/common.actions";
import * as userActions from "./../../../../../actions/user.actions";

const subHeader = {
  items: [
    {
      caption: "Matches",
      url: "/member/projects/matches"
    },
    {
      caption: "Pitches",
      url: "/member/projects/pitches"
    },
    {
      caption: "SOWs",
      url: "/member/projects/sows"
    },
    {
      caption: "Completed",
      url: "/member/projects/completed"
    },
    {
      caption: "Invoices",
      url: "/member/projects/invoices"
    }
  ],
  activeItem: 1,
  track: true
};

const STATUS_ID_APPROVED = 4;
const STATUS_ID_MATCHED = 5;
const STATUS_ID_PITCHED = 6;
const STATUS_ID_PAUSED = 10;

class PitchesContainer extends Component {
  constructor(props) {
    super(props);

    props.projectActions.getPitches();

    if (_.isEmpty(this.props.stats)) {
      this.props.userActions.getUserStats(1);
    }
  }

  componentDidMount() {
    this.props.commonActions.setSubHeader(subHeader);
  }

  componentWillUnmount() {
    this.props.commonActions.setSubHeader({});
  }

  render() {
    const pitches = _.filter(this.props.project.pitches, pitch => {
      // We're only supposed to display pitches of the following statuses:
      const projectVisible =
        pitch.match.project.status_id == STATUS_ID_APPROVED ||
        pitch.match.project.status_id == STATUS_ID_MATCHED ||
        pitch.match.project.status_id == STATUS_ID_PITCHED ||
        pitch.match.project.status_id == STATUS_ID_PAUSED;

      return !pitch.accepted && pitch.accepted !== false && projectVisible;
    });

    return <Pitches pitches={pitches} />;
  }
}

const mapStateToProps = state => {
  return {
    project: state.project,
    stats: state.user.stats
  };
};

const mapDispatchToProps = dispatch => {
  return {
    projectActions: bindActionCreators(projectActions, dispatch),
    commonActions: bindActionCreators(commonActions, dispatch),
    userActions: bindActionCreators(userActions, dispatch)
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PitchesContainer);



// WEBPACK FOOTER //
// ./src/routes/candidate/projects/pitches/containers/PitchesContainer.js